/**
 * OVERRIDE FileView.jsx
 */

import FileView from '../../../../components/View/FileView';

export default FileView;